export default "/static/explore/52637a98b6af851089caccbad8aa8eb115d3d065/_next/static/images/reminders-default-bg-c895cd003dffc5cebf1fcdc4cf38526b.jpg";